import { FC } from 'react'
import useHomeStockStore from '../../store/home/useHomeStockStore'
import { BaseModalFooter } from '../common/Modal'
import { useStock } from '../../hooks/useStock'

type InitialInfoButtonProps = {
  onClose: () => void
  isBack: () => void
}

export const InitialInfoButton: FC<InitialInfoButtonProps> = ({ onClose, isBack }) => {
  const { setTanksInfoBorderColor, stockData, typeError } = useHomeStockStore()
  const stockMutation = useStock()

  const chekTanksValuesBeforeFinish = () => {
    setTanksInfoBorderColor()
    if (
      stockData &&
      stockData.every((item) => item.count !== null && item.moveDate !== null) &&
      !typeError
    ) {
      stockMutation.mutate(stockData, {
        onSuccess: () => {
          onClose()
        }
      })
    }
  }

  return (
    <BaseModalFooter
      back="Back"
      next="Finish"
      backOnPress={() => {
        onClose()
        isBack()
      }}
      nextOnPress={chekTanksValuesBeforeFinish}
    />
  )
}
